export default __webpack_public_path__ + "assets/clear-night.9ed9031b.svg";